import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const Tab = ({ label, onClick, isActive }) => {
  return (
    <button
      onClick={onClick}
      className={`shrink-0 border-b-2 px-1 pb-2 text-sm font-medium focus:outline-none ${
        isActive
          ? "border-green-500 text-green-600"
          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-white"
      }`}
    >
      {label}
    </button>
  );
};

const renderImage = (image, i) => {
  return (
    <img
      className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2 m-2"
      src={process.env.REACT_APP_API_IMAGE_URL + image}
      alt="Preview"
    />
  );
};

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  let result = Array.isArray(data) ? data.find((item) => item.id === id) : null;

  const [activeTab, setActiveTab] = useState("1");

  const handleTabClick = (label) => {
    setActiveTab(label);
  };
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }`;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openZoomModal = (image) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white p-2 w-1/2 rounded-md"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn
          onClose={closeModal}
          />
          <div className="hidden sm:block">
            <nav className="mb-2 flex gap-6" aria-label="Tabs">
              <Tab
                label="Basic Details"
                className="dark:text-white"
                onClick={() => handleTabClick("1")}
                isActive={activeTab === "1"}
              />
              {result && result["Vendor Type"] !== "Owner" && (
                <Tab
                  label="Company Info"
                  className="dark:text-white"
                  onClick={() => handleTabClick("2")}
                  isActive={activeTab === "2"}
                />
              )}

              <Tab
                label="ID Proof Details"
                className="dark:text-white"
                onClick={() => handleTabClick("3")}
                isActive={activeTab === "3"}
              />
            </nav>
          </div>

          {/* Tab Content */}
          <div
            style={{
              maxHeight: "65vh",
              overflowY: "scroll",
              scrollbarWidth: "thin",
            }}
          >
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Title
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.name_title}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Contact Person
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Email
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.email_id}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Password{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.password}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Contact No
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result ? result["mobile_no"] : ""}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Alternate Contact No
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.al_mobile_no
                        ? result["al_mobile_no"]
                        : "Not Available"}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Key Manager{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.transport_head}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Seller{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.seller}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Created By{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.added_by_emp}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Reject Reason{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.reject_reason ? result?.reject_reason : "-"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Agent Type{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.agent_type}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
            {activeTab === "2" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Company Name
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 ">
                      {result ? result["company_name"] : ""}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Company Type
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20 ">
                      {result ? result["company_type"] : ""}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Company Address
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result ? result["address"] : ""}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      City,State,Country
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.city_name +
                        "," +
                        result?.state_name +
                        "," +
                        result?.country_name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Pincode
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.pincode}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
            {activeTab === "3" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Pan Number
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.pan_no ? result?.pan_no : "Not available"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Gst Number
                    </dt>
                    <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                      {result?.gst_no ? result?.gst_no : "Not available"}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Pan Image
                    </dt>
                    {result.pan_front_side_img ? (
                      <dd
                        className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                        onClick={() => openZoomModal(result.pan_front_side_img)}
                      >
                        {result && Array.isArray(result.pan_front_side_img) && (
                          <>
                            {result.pan_front_side_img.map((image, i) =>
                              renderImage(image, i)
                            )}
                          </>
                        )}

                        {result &&
                          result.pan_front_side_img &&
                          renderImage(result.pan_front_side_img)}
                      </dd>
                    ) : (
                      <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                        Not available
                      </dd>
                    )}
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-whitep">
                      Gst Image
                    </dt>
                    {result.gst_front_side_img ? (
                      <dd
                        className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                        onClick={() => openZoomModal(result.gst_front_side_img)}
                      >
                        {result && Array.isArray(result.gst_front_side_img) && (
                          <>
                            {result.gst_front_side_img.map((image, i) =>
                              renderImage(image, i)
                            )}
                          </>
                        )}

                        {result &&
                          result.gst_front_side_img &&
                          renderImage(result.gst_front_side_img)}
                      </dd>
                    ) : (
                      <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                        Not available
                      </dd>
                    )}
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Company Registration
                    </dt>
                    {result.company_reg_cer_img ? (
                      <dd
                        className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                        onClick={() =>
                          openZoomModal(result.company_reg_cer_img)
                        }
                      >
                        {result &&
                          Array.isArray(result.company_reg_cer_img) && (
                            <>
                              {result.company_reg_cer_img.map((image, i) =>
                                renderImage(image, i)
                              )}
                            </>
                          )}

                        {result &&
                          result.company_reg_cer_img &&
                          renderImage(result.company_reg_cer_img)}
                      </dd>
                    ) : (
                      <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                        Not available
                      </dd>
                    )}
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Company Logo
                    </dt>
                    {result.company_logo ? (
                      <dd
                        className="text-gray-700 dark:text-white sm:col-span-2 pl-20"
                        onClick={() => openZoomModal(result.company_logo)}
                      >
                        {result && Array.isArray(result.company_logo) && (
                          <>
                            {result.company_logo.map((image, i) =>
                              renderImage(image, i)
                            )}
                          </>
                        )}

                        {result &&
                          result.company_logo &&
                          renderImage(result.company_logo)}
                      </dd>
                    ) : (
                      <dd className="text-gray-700 dark:text-white sm:col-span-2 pl-20">
                        Not available
                      </dd>
                    )}
                  </div>
                </dl>
              </div>
            )}
          </div>

                  {isModalOpen && (
  <div
    className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
    onClick={(e) => {
      // If the clicked element is the overlay itself, close modal
      if (e.target === e.currentTarget) {
        closeZoomModal();
      }
    }}
  >
    <div className="bg-white p-4 rounded-lg max-w-md w-full relative">
      <button
        onClick={closeZoomModal}
        className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white absolute top-2 right-2 text-2xl"
      >
        <IoIosClose />
      </button>

      <img
        src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
        alt="Selected Company Logo"
        className="w-full h-auto rounded-lg"
      />
    </div>
  </div>
)}
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
